<template>
  <div class="feedback-view">
    <span class="btn-feedback-view d-none d-sm-block" @click="showDialog">{{$t('provider_detail.feedback.more')}} <i class="fas fa-chevron-right"></i></span>
    <span class="btn-feedback-view d-sm-none d-block" @click="showDialog"><i class="fas fa-chevron-right"></i></span>
    <div
      ref="FeedbackDetail"
      class="modal fade pl-0"
      role="dialog"
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header d-flex align-items-center">
            <div class="modal-title">{{$t('provider_detail.feedback.name')}}</div>
            <div class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </div>
          </div>
          <div class="modal-body custom-modal-body">
            <div class="container-fluid">
              <div class="row">
                <div class="col-4 col-sm-3">
                      <ul v-if="categories && categories.data && services">
                        <li class="service" v-for="category in categories.data" :key="category._id" v-show="services[category._id]"  :class="{'active': (selectedCategory == category._id)}" >
                          <span class="service-body" v-if="services[category._id]" @click="selectCategory(category._id)">
                            <span class="name">{{category.name}}</span>
                            <span class="rate">
                              <i class="fas fa-star"></i> 
                              {{ caculateRating(services[category._id].totalStar,services[category._id].totalRate)}}/5
                            </span>
                          </span>
                        </li>
                      </ul>
                </div>
                <div class="col-8 col-sm-9">
                   <div class="w-100 d-flex justify-content-center" v-if="feedbacks.loading">
                      <span class="loading p-2" v-if="feedbacks.loading"></span>
                  </div>
                    <ul class="feedbacks col-12" v-if="feedbacks.data && feedbacks.data.length && !feedbacks.loading">
                      <li  v-for="feedback in feedbacks.data" :key="feedback._id">
                        <div class="feedback">
                          <div class="avatar-container">
                            <img v-if="getFeedbackUserProfile(feedback) && getFeedbackUserProfile(feedback).avatar" class="avatar" :src="getFeedbackUserProfile(feedback).avatar" />
                            <img v-else class="avatar" src="~@/assets/default-avatar.svg" />
                          </div>
                          <div class="content-container">
                            <div class="display-name">{{getFeedbackUserProfile(feedback).displayName}}</div>
                            <div class="stars"><i class="fas fa-star" v-for="(star, index) in feedback.star" :key="index"></i></div>
                            <div class="content">{{feedback.comment}}</div>
                            <div class="created-at">{{feedback.createdAt | date}}</div>
                          </div>
                          <div class="favorite-container">
                            <span class="total-likes">{{feedback.totalLike}}</span>
                            <i class="fas fa-thumbs-up"></i>
                          </div>
                        </div>
                        <div class="reply" v-if="feedback.reply">
                          <div class='header'>{{$t('provider_detail.feedback.response')}}</div>
                          <span class="date">{{feedback.replyAt | date}}</span>
                          <div class="content">{{feedback.reply}}</div>
                        </div>
                      </li>
                    </ul>
                    <div v-else-if="!feedbacks.loading" class="message" >
                         {{$t('provider_detail.feedback.none')}}
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";

export default {
  name: "FeedbackView",
  props: {
    providerId: String
  },
  data() {
    return {
      // providerId: "5e6766334bb4fa99ebae4e64",
      services: {},
      selectedCategory: null,
      feedbacks: {
        loading: false,
        resultKey: "",
        data: []
      },
      userProfiles: {}
    };
  },
  filters: {
    date(value) {
      if (!value || value.length == 0) {
        return "#";
      }
      return moment(value).format("DD/MM/YYYY");
    }
  },
  computed: {
    ...mapState(["categories"])
  },
  methods: {
    caculateRating(totalStar, totalRate) {
      let results = totalStar / totalRate;
      if (totalStar == 0 && totalRate == 0) {
        return 0;
      }
      if (results % 1 != 0) {
        results = results.toFixed(1);
      }

      return Number(results);
    },
    showDialog: function() {
      var $ = global.jQuery;
      $(this.$refs.FeedbackDetail).modal("show");
      this.listServices();
    },
    selectCategory(id) {
      this.selectedCategory = id;
      this.showFeedback();
    },
    getFeedbackUserProfile(feedback) {
      return this.userProfiles[feedback.user] || {};
    },
    async fetchUserProfiles(userIds) {
      const {
        data: { results }
      } = await this.$store.$oddjob.users.find({ limit: 100, userIds });
      if (results) {
        results.forEach(item => {
          this.userProfiles[item._id] = item;
        });
      }
    },
    async showFeedback() {
      this.feedbacks.data = [];
      this.feedbacks.loading = true;
      const {
        data: { results }
      } = await this.$store.$oddjob.serviceProviders.getFeedbackByServiceId(
        this.services[this.selectedCategory]._id
      );
      const userIds = results.map(item => item.user);
      await this.fetchUserProfiles(userIds);

      this.feedbacks.data = results;
      this.feedbacks.loading = false;
    },
    selectDefaultCategory() {
      for (let category of this.categories.data) {
        if (this.services[category._id]) {
          this.selectCategory(category._id);
          return;
        }
      }
    },
    async listServices() {
      try {
        const {
          data: { results }
        } = await this.$store.$oddjob.serviceProviders.getServicesByProviderId(
          this.providerId
        );
        if (results && results.length > 0) {
          this.services = {};
          results.forEach(item => {
            if(item.status == "active"){
              item.currentRating = item.totalRate > 0 ? item.totalStar / (item.totalRate * 5) : 0;
              item.currentRating = Math.ceil(item.currentRating);
              this.services[item.category] = item;
            }
          });

          this.selectDefaultCategory();
          // const data = results.map(async service => {
          //   service.category = await this.getCategoryById(service.category);
          //   return service;
          // });
          // return Promise.all(data);
        }
        return [];
      } catch (e) {
        console.log("API service failed", e);
      }
    }
  }
};
</script>

<style scoped lang="scss">
.custom-modal-body{
  padding: 1rem 0px;
}
.feedback-view {
  display: inline-block;
  .btn-feedback-view {
    display: inline-block;
    color: #dadada;
    align-items: center;
    font-size: 12px;
    line-height: 24px;
    cursor: pointer;
    .arrow-right{

    }
    &:hover {
      text-decoration: underline;
      cursor: pointer;
    }
  }
}
ul.feedbacks {
  display: block;
  li {
    border-top: 1px solid #ffe4a2;
    // padding: 10px 0 0;
    margin: 0;
    list-style: none;
    &:first-child {
      border-top: 0;
    }
  }
  .feedback {
    padding: 10px 0px 10px 0px;
    margin: 0 0 10px;
    display: flex;
    .avatar-container {
      .avatar {
        // background-color: gray;
        width: 40px;
        height: 40px;
        border-radius: 10px;
      }
      padding-right: 10px;
    }
    .content-container {
      flex: 1;
      .display-name {
        font-weight: bold;
        padding-bottom: 3px;
      }
      .stars {
        font-size: 10px;
        color: #ffbe17;
      }
      .content {
        padding: 5px 0;
      }
      .created-at {
        font-size: 0.9em;
        color: gray;
      }
    }
    .favorite-container {
      display: inline-block;

      .total-likes {
        padding-right: 3px;
        display: inline-block;
        vertical-align: middle;
      }
      .fas {
        font-size: 0.8em;
        display: inline-block;
      }
    }
  }

  .reply {
    border-top: 1px solid #e4e4e4;
    padding: 10px 0;
    .header {
      font-weight: bold;
      padding-bottom: 3px;
    }
    .date {
      font-size: 0.9em;
      color: gray;
    }
  }
}
.feedback-view {
  color: black;
  font-weight: normal;
}
.modal-header {
  .close{
    opacity: 1;
    text-shadow: none;
    cursor: pointer;
    span{
      font-size: 30px;
    }
    &:hover{
      opacity: .5;
    }
  }
  .modal-title {
    color: black;
    font-weight: bold;
  }
}
ul {
  padding: 0;
  margin: 0;
  li.service {
    display: block;
    list-style: none;
    padding: 0 0 10px;
    margin: 0;
    display: block;
    .service-body {
      cursor: pointer;
      display: inline-block;
      padding: 10px 10px;
      border-radius: 10px;
      background-color: white;
      .name {
        font-size: 0.9em;
        // font-size: 1.1em;
        font-weight: bold;
        display: block;
      }
      .rate {
        font-size: 0.8em;
        display: block;
        .fas {
          font-size: 0.9em;
        }
      }
    }
    &.active {
      .service-body {
        background-color: #ffbe17;
      }
    }
  }
}

  .loading {
    margin: 20px;
    display: inline-block;
    border: 5px solid #f3f3f3;
    border-radius: 50%;
    border-top: 5px solid #ffbe17;
    width: 30px;
    height: 30px;
    -webkit-animation: spin 0.9s linear infinite;
    animation: spin 0.8s linear infinite;
  }
  @-webkit-keyframes spin {
      0% {
          -webkit-transform: rotate(0deg);
      }
      100% {
          -webkit-transform: rotate(360deg);
      }
  }

  @keyframes spin {
      0% {
          transform: rotate(0deg);
      }
      100% {
          transform: rotate(360deg);
      }
  }

@media screen and (min-width: 1024px){
  .feedback-view {
    .btn-feedback-view {
      font-size: 14px;
      line-height: 24px;
    }
  }
}
</style>
